import React from 'react';
import { Route } from 'react-router-dom';

import { UserRolesEnum } from 'commons/types/user.roles.enum';
import PrivateRoute from 'commons/utils/privateRoute';
import HomePage from 'pages/homepage/HomePage';
import HomePageInbound from 'pages/homepage/HomePageInbound';
import HomePageOutbound from 'pages/homepage/HomePageOutbound';
import HomePageSTO from 'pages/homepage/HomePageSTO';

import { HOME_ROUTES } from './constants/home-routes.constant';

export const useHomeRouter = (): React.JSX.Element => {
  return (
    <>
      <Route
        path={HOME_ROUTES.HOME_PAGE}
        element={
          <PrivateRoute
            roles={[UserRolesEnum.ADMIN, UserRolesEnum.SUPER_ADMIN]}
            isHomePage
          />
        }
      >
        <Route path={HOME_ROUTES.OUTBOUND} element={<HomePageOutbound />} />
      </Route>
      <Route
        path={HOME_ROUTES.HOME_PAGE}
        element={
          <PrivateRoute
            roles={[
              UserRolesEnum.ADMIN,
              UserRolesEnum.SUPER_ADMIN,
              UserRolesEnum.REPLENISH,
            ]}
          />
        }
      >
        <Route path={HOME_ROUTES.HOME_PAGE} element={<HomePage />} />
        <Route path={HOME_ROUTES.INBOUND} element={<HomePageInbound />} />
        <Route path={HOME_ROUTES.STO} element={<HomePageSTO />} />
      </Route>
    </>
  );
};
